<template>
  <AppEditForm
    padding
    class="row q-px-md full-width"
    @save="save"
    :edit="edit"
    :new="isNew"
    dense
  >
    <div class="col-12 col-sm-8 q-mt-md row content-start">
      <div class="col-6 q-px-sm">
        <AppInput
          label="Número do processo paradigma"
          :mask="appStore.procPjeMask"
          v-model="numeroProcesso"
          required
          dense
        />
      </div>
      <div class="col-6 q-px-sm"/>
      <div class="col-6 q-px-sm">
        <AppInput
            label="Processo STJ"
            v-model="numeroProcessoSTJ"
            dense
        />
      </div>
      <div class="col-6 q-px-sm">
        <AppInput
            label="Situação STJ"
            v-model="situacaoSTJ"
            dense
        />
      </div>
      <div class="col-6 q-px-sm">
        <AppInput
            label="Processo STF"
            v-model="numeroProcessoSTF"
            dense
        />
      </div>
      <div class="col-6 q-px-sm">
        <AppInput
            label="Situação STF"
            v-model="situacaoSTF"
            dense
        />
      </div>

    </div>
    <div class="col-1 ">
      <div class="q-pa-sm justify-end">
        <q-btn
          icon="add"
          color="positive"
          type="submit"
          fab
          class="on-right"
        />
      </div>
    </div>
  </AppEditForm>
</template>


<script setup>
import AppEditForm from "../app/AppEditForm.vue";
import AppInput from "../app/AppInput.vue";
import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";
import { useAppStore } from "@/store/app-store";

import {ref, defineProps, defineEmits, watch} from "vue";

const appStore = useAppStore();
const procStore = useProcessoParadigmaStore();

const emit = defineEmits(["update:modelValue"]);
const save = v => {
  procStore.save();
  numeroProcesso.value = "";
  numeroProcessoSTJ.value = "";
  situacaoSTJ.value = "";
  numeroProcessoSTF.value = "";
  situacaoSTF.value = "";

  emit("update:modelValue", v);
};

const numeroProcesso = ref(null);
const situacaoSTJ = ref(null);
const situacaoSTF = ref(null);
const numeroProcessoSTJ = ref(null);
const numeroProcessoSTF = ref(null);

const props = defineProps({ modelValue: {} });
numeroProcesso.value = props.modelValue ? props.modelValue.numero : ref(null);
numeroProcessoSTJ.value = props.modelValue ? props.modelValue.numeroProcessoSTJ : ref(null);
situacaoSTJ.value = props.modelValue ? props.modelValue.situacaoSTJ : ref(null);
numeroProcessoSTF.value = props.modelValue ? props.modelValue.numeroProcessoSTF : ref(null);
situacaoSTF.value = props.modelValue ? props.modelValue.situacaoSTF : ref(null);

procStore.numero = numeroProcesso.value;
procStore.numeroProcessoSTJ = numeroProcessoSTJ.value
procStore.situacaoSTJ = situacaoSTJ.value
procStore.numeroProcessoSTF = numeroProcessoSTF.value
procStore.situacaoSTF = situacaoSTF.value

watch(numeroProcesso, () => (procStore.numero = numeroProcesso.value));
watch(numeroProcessoSTJ, () => (procStore.numeroProcessoSTJ = numeroProcessoSTJ.value));
watch(situacaoSTJ, () => (procStore.situacaoSTJ = situacaoSTJ.value));
watch(numeroProcessoSTF, () => (procStore.numeroProcessoSTF = numeroProcessoSTF.value));
watch(situacaoSTF, () => (procStore.situacaoSTF = situacaoSTF.value));

const edit = ref(true);
const isNew = ref(true);
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
